import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { Feature } from 'types/user'

import { selectCurrentUser } from 'store/users/users.selectors'

import classes from './style.module.css'

export const GlobalOtkIdAlert: React.FC = () => {
  const currentUser = useSelector(selectCurrentUser)

  const hasOtkIdAlert = currentUser?.features?.[Feature.HAS_OTK_ID_ALERT]

  if (!hasOtkIdAlert || !process.env.REACT_APP_OTK_ID_PROFILE_URL) return null

  return (
    <div className={classNames('text-light text-center bg-info', classes.banner)}>
      У вас есть события в{' '}
      <a
        href={process.env.REACT_APP_OTK_ID_PROFILE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-light"
        style={{ textDecoration: 'underline' }}
      >
        Личном Кабинете
      </a>
    </div>
  )
}

export default GlobalOtkIdAlert
